import React from 'react'

//	S T Y L E

import './com-button-generic.scss'

//	S T A T E S   -   P R O P S

import { props___ComButtonGenericComponent } from './com-button-generic.state';

//	C L A S S

export default class ComButtonGenericComponent extends React.Component<props___ComButtonGenericComponent, {}> {

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___ComButtonGenericComponent,
	) {
		super(props);
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			<div className="com-button-generic---container" onClick={() => { if (this.props.event___onClick) { this.props.event___onClick(); }}}>
				<i className={ this.props.icon }></i>
				<span>{ this.props.text }</span>
			</div>
		</>;
	}

//#endregion

}